import * as React from 'react';
import { IItemClickParams } from '@cian/geosuggest-widget';

export interface IUseOnItemClick {
  setSuggestValue(value: string): void;
  validateAddress(value: string): void;
}

export const useOnItemClick = ({ setSuggestValue, validateAddress }: IUseOnItemClick) => {
  return React.useCallback(
    ({ title }: IItemClickParams) => {
      setSuggestValue(title);
      validateAddress(title);
    },
    [setSuggestValue, validateAddress],
  );
};
